import {KODATA_MAP_CATEGORIES} from '@/constants';
import {KodataCategory} from '@/enums';
import {KodataCategoryGroup, KodataStoreQueryFilter} from '../@types';
import {KodataStoresQueryFilters} from '../enums';

export const convertToMyfcCategoryFromKodata = (value: string) => {
  const CATEGORY_NAME_MAPPING_PARES: {[key: string]: string} = {
    [KodataCategory.CAFE]: '커피',
  };

  return CATEGORY_NAME_MAPPING_PARES[value] ?? value;
};

export const convertToKodataCategory = (value: string) => {
  const CATEGORY_NAME_MAPPING_PARES: {[key: string]: KodataCategory} = {
    커피: KodataCategory.CAFE,
  };

  return CATEGORY_NAME_MAPPING_PARES[value] ?? value;
};

export const isValidKodataCategory = ({
  category,
  categoryDetail,
}: KodataCategoryGroup) => {
  if (!category || !categoryDetail) {
    return false;
  }

  const catDetails: string[] = KODATA_MAP_CATEGORIES[category];

  if (!catDetails || !catDetails.includes(categoryDetail)) {
    return false;
  }

  return true;
};

export const convertKodataStoresFilterFormat = (
  filters: Array<{key: KodataStoresQueryFilters; value: any}>
): KodataStoreQueryFilter => {
  const obj: any = filters.reduce((acc, {key, value}) => {
    if (key === KodataStoresQueryFilters.salesRanges) {
      if (!value?.length) {
        return acc;
      }

      let arr = [...value];

      if (!Array.isArray(arr[0])) {
        arr = [arr];
      }

      acc[key] = arr.map((i: number[]) => {
        const range: any = {};

        const start = i[0];

        if (i.length > 1) {
          const end = i[i.length - 1];

          if (start === end) {
            range.min = start + 1;
          } else {
            range.min = start;
            range.max = end;
          }
        } else {
          range.min = start;
        }

        return range;
      });
    } else {
      acc[key] = value;
    }

    return acc;
  }, {} as {[key: string]: any});

  return obj;
};

export const getKoreanNumber = (num: number) => {
  const start = 10_000_000;
  const units = ['억', '천만'];

  if (!num || num < start) {
    return num;
  }

  let rest: number = num;

  return [start * 10, start]
    .reduce((acc: number[], cur) => {
      acc.push(Math.floor(rest / cur));
      rest %= cur;

      return acc;
    }, [])
    .map((i, idx) => (i > 0 ? `${i}${units[idx]}` : ''))
    .join(' ')
    .trim();
};

export const toStringFromRange = (range: number[], format: string = '개') => {
  if (!range?.length) {
    return '';
  }

  const start = range[0];

  if (range.length === 1) {
    return `${getKoreanNumber(start)}${format} 초과`;
  }

  const end = range[range.length - 1];

  if (start === end) {
    return `${getKoreanNumber(start + 1)}${format} 미만`;
  }

  if (start) {
    return `${getKoreanNumber(start)}~${getKoreanNumber(end)}${format}`;
  } else {
    return `${getKoreanNumber(end)}${format} 이하`;
  }
};
